import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const I = "bg-transparent border border-[color:var(--border)] px-3 py-2 text-sm";

export default function AdminInventory() {
  const [movements, setMovements] = useState([]);
  const [products, setProducts] = useState([]);
  const [f, setF] = useState({ sku: "", size: "", delta: "", reason: "adjustment", note: "" });

  const loadMovements = () => api.get("/admin/inventory/movements").then((r) => setMovements(r.data));
  const loadProducts = () => api.get("/products", { params: { admin_view: true, limit: 500 } }).then((r) => setProducts(r.data.filter((p) => p.production_type === "READY_STOCK")));

  useEffect(() => { loadMovements(); loadProducts(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/inventory/adjust", { ...f, delta: Number(f.delta) });
      toast.success("Stok diperbarui");
      setF({ sku: "", size: "", delta: "", reason: "adjustment", note: "" });
      loadMovements(); loadProducts();
    } catch (err) { toast.error(err?.response?.data?.detail || "Gagal"); }
  };

  const prod = products.find((p) => p.article_code === f.sku);

  return (
    <div>
      <h1 className="display text-4xl md:text-6xl mb-6">INVENTORY</h1>
      <div className="grid md:grid-cols-2 gap-6 mb-8">
        <form onSubmit={submit} className="border border-[color:var(--border)] p-6 space-y-3">
          <div className="text-[10px] tracking-widest text-neutral-500">ADJUST STOK (READY_STOCK)</div>
          <select className={I} value={f.sku} onChange={(e) => setF({ ...f, sku: e.target.value, size: "" })}>
            <option value="">— pilih SKU —</option>
            {products.map((p) => <option key={p.id} value={p.article_code}>{p.article_code} · {p.name}</option>)}
          </select>
          <select className={I} value={f.size} onChange={(e) => setF({ ...f, size: e.target.value })} disabled={!prod}>
            <option value="">— pilih ukuran —</option>
            {(prod?.sizes || []).map((s) => <option key={s} value={s}>{s} (current: {(prod?.size_stock || {})[s] || 0})</option>)}
          </select>
          <input type="number" className={I} placeholder="Delta (+ tambah, − kurangi)" value={f.delta} onChange={(e) => setF({ ...f, delta: e.target.value })} />
          <select className={I} value={f.reason} onChange={(e) => setF({ ...f, reason: e.target.value })}>
            {["opening","added","adjustment","order_cancelled","return_refund"].map((x) => <option key={x} value={x}>{x}</option>)}
          </select>
          <input className={I} placeholder="Catatan (opsional)" value={f.note} onChange={(e) => setF({ ...f, note: e.target.value })} />
          <button className="bg-white text-black px-6 py-2 text-xs tracking-widest">SIMPAN</button>
          <p className="text-[10px] text-neutral-500">MADE_TO_ORDER produk tidak menampilkan stok — order langsung diteruskan ke produksi.</p>
        </form>
        <div className="border border-[color:var(--border)] p-6">
          <div className="text-[10px] tracking-widest text-neutral-500 mb-3">READY_STOCK — SNAPSHOT PER SIZE</div>
          {products.length === 0 ? <div className="text-neutral-500 text-sm">Belum ada produk READY_STOCK.</div> : (
            <table className="w-full text-xs">
              <thead className="text-[10px] tracking-widest text-neutral-500">
                <tr className="border-b border-[color:var(--border)]"><th className="p-2 text-left">SKU</th><th className="p-2 text-left">NAME</th><th className="p-2 text-left">STOCK BY SIZE</th></tr>
              </thead>
              <tbody>
                {products.map((p) => (
                  <tr key={p.id} className="border-b border-[color:var(--border)]">
                    <td className="p-2 mono">{p.article_code}</td>
                    <td className="p-2">{p.name}</td>
                    <td className="p-2 mono">{(p.sizes || []).map((s) => `${s}:${(p.size_stock || {})[s] || 0}`).join(" · ")}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
      <div className="border border-[color:var(--border)]">
        <div className="p-4 text-[10px] tracking-widest text-neutral-500 border-b border-[color:var(--border)]">INVENTORY MOVEMENTS (200 terbaru)</div>
        <table className="w-full text-xs">
          <thead className="text-[10px] tracking-widest text-neutral-500">
            <tr className="border-b border-[color:var(--border)]">
              <th className="p-2 text-left">AT</th><th className="p-2 text-left">SKU</th><th className="p-2 text-left">SIZE</th>
              <th className="p-2 text-right">DELTA</th><th className="p-2 text-left">REASON</th><th className="p-2 text-left">ORDER</th><th className="p-2 text-left">NOTE</th>
            </tr>
          </thead>
          <tbody>
            {movements.map((m) => (
              <tr key={m.id} className="border-b border-[color:var(--border)]">
                <td className="p-2 mono">{(m.at || "").slice(0, 19).replace("T", " ")}</td>
                <td className="p-2 mono">{m.sku}</td>
                <td className="p-2 mono">{m.size}</td>
                <td className={`p-2 text-right tabular-nums ${m.delta > 0 ? "text-emerald-400" : m.delta < 0 ? "text-[color:var(--accent)]" : "text-neutral-400"}`}>{m.delta > 0 ? "+" : ""}{m.delta}</td>
                <td className="p-2">{m.reason}</td>
                <td className="p-2 mono">{m.order_number || "—"}</td>
                <td className="p-2 text-neutral-500">{m.note || ""}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
